import React, { useState, useEffect } from "react"
import { useSelector, useDispatch, batch } from "react-redux"
import { useNavigate } from "react-router-dom"

// UI Materials
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import "/node_modules/flag-icons/css/flag-icons.min.css"

import user from '../reducers/user'
// import reply from '../reducers/reply'




import { API_URL } from '../reusable/urls'

// import InstructionsInitialEN from './InstructionsInitialEN'
import InstructionsLogin from "./InstructionsLogin"

import "./login.css";

const Login = () => {
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')


    const [mode, setMode] = useState(null)
    const [language, setLanguage] = useState('en')

    console.log(language)

    
    // const id= req.params.id
    // const [registered, setRegistered] = useState(false)


    const accessToken = useSelector(store => store.user.accessToken)
    const errors = useSelector((store) => store.user.errors)


    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        if (accessToken) {
            navigate('/')
        }
    }, [accessToken, navigate])

    const onFormSubmit = (e) => {
        e.preventDefault()

        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ username, password })
        }

        fetch(API_URL(mode), options)
            .then(res => res.json())
            .then(data => {
                if(data.success) {
                    batch(() => {
                        dispatch(user.actions.setUsername(data.username))
                        dispatch(user.actions.setAccessToken(data.accessToken))
                        dispatch(user.actions.setRole(data.role))
                        dispatch(user.actions.setId(data.userID))
                        dispatch(user.actions.setRegistered(data.registered))
                        dispatch(user.actions.setErrors(null))
                    })
                    
                } else {
                    batch(() => {
                        dispatch(user.actions.setErrors(data))
                        dispatch(user.actions.setUsername(null))
                        dispatch(user.actions.setAccessToken(null))
                    })
                }
            })
            dispatch(user.actions.setLanguage(language))
    }

    return (
        <>
            <div className="language-selector">
                    
                    <input
                        type="radio"
                        id="en"
                        name="language"
                        value={language}
                        onChange={() => setLanguage("en")}
                    />
                    <label htmlFor="en"><span className="fi fi-gb"></span></label>

                    <input
                        type="radio"
                        id="sw"
                        name="language"
                        value={language}
                        onChange={() => setLanguage("sw")}
                    />
                    <label htmlFor="sw"><span className="fi fi-se"></span></label>

                    <input
                        type="radio"
                        id="es"
                        name="language"
                        value={language}
                        onChange={() => setLanguage("es")}
                    />
                    <label htmlFor="es"><span className="fi fi-es"></span></label>
                </div>
            <div className="login-template">
                

                <h1 className="login-title">Questionnaire: <br/>Diabetes App management</h1>
                    <form onSubmit={onFormSubmit}>

                        <Box
                            sx={{
                                '& > :not(style)': { m: 1, width: '25ch' }
                            }}
                            noValidate
                            autoComplete="off"
                            type="text" 
                            value={username} 
                            onChange={(e) => setUsername(e.target.value)}
                            >
                            <TextField 
                                required
                                id="outlined-required"
                                label="User Name" 
                                color="secondary" 
                                focused />
                        </Box>
                        
                        <Box
                            sx={{
                                '& > :not(style)': { m: 1, width: '25ch' }
                            }}
                            noValidate
                            autoComplete="off"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            >
                            <TextField 
                                required
                                id="outlined-password-input"
                                label="Password" 
                                type="password"
                                autoComplete="current-password"
                                color="secondary" 
                                focused />
                        </Box>

                        <button 
                            type="submit" 
                            onClick={() => setMode('signin')}
                            className="btn-signin"
                            >
                            Sign in
                        </button>
                        <button 
                            type="submit" 
                            onClick={() => setMode('signup')}
                            className="btn-signup"
                        >
                            Sign up
                        </button>
                        
                    </form>
                    <div className="instructions-login">
                        <InstructionsLogin language={language}/>
                    </div>

                    {errors && <div className="errors">{errors.message}</div>}
                    
                    
            </div>
            
        </>
    )
}

export default Login
